module.exports = __webpack_public_path__ + "static/media/seeds-of-life-thumbnail_desktop.85759ae0.jpg";